import {
	AddressModel,
	DEFAULT_ADDRESS,
	DEFAULT_EMPLOYEE,
	DEFAULT_TAX_ACCOUNTANT_NAME,
	DEFAULT_TAX_CORPORATION_NAME,
	EmployeeModel,
	REGISTER_STATUS_KEY_TYPE,
	TaxAccountantNameModel,
	TaxCorporationNameModel
} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	areaBlock: z.boolean(),
	updatedAt: z.string().nullable(),
	registerStatus: REGISTER_STATUS_KEY_TYPE.nullable().default("PENDING"),
	taxAccountantId: z.string(),
	taxAccountantName: TaxAccountantNameModel.model,
	taxCorporationName: TaxCorporationNameModel.model,
	address: AddressModel.model,
	managerEmployee: EmployeeModel.model.nullable().default(DEFAULT_EMPLOYEE),
	highSchool: z.string().nullable().default(""),
	university: z.string().nullable().default(""),
	graduateSchool: z.string().nullable().default(""),
	certificates: z.string().nullable().default(""),
	workHistory: z.string().nullable().default(""),
	genderCode: z.number().nullable().default(-1),
	birthYear: z.string().nullable().default(""),
	birthplace: z.string().nullable().default(""),
	numberOfExam: z.string().nullable().default(""),
	registeredDate: z.string().nullable(),
	//new
	areaBlockLocation: z.string().nullable().default(""),
	areaBlockLocationDetail: z.string().nullable().default("")
});

const model = schema.transform((values) => ({
	...values
}));

export const DetailResModel = { schema, model };
export type IDetailResModel = z.infer<typeof DetailResModel.model>;
export const DEFAULT_DETAIL_RES: IDetailResModel = {
	areaBlock: false,
	updatedAt: null,
	registerStatus: "PENDING",
	taxAccountantId: "",
	taxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME,
	taxCorporationName: DEFAULT_TAX_CORPORATION_NAME,
	address: DEFAULT_ADDRESS,
	managerEmployee: DEFAULT_EMPLOYEE,
	highSchool: "",
	university: "",
	graduateSchool: "",
	certificates: "",
	workHistory: "",
	genderCode: -1,
	birthYear: "",
	birthplace: "",
	numberOfExam: "",
	registeredDate: null,
	areaBlockLocation: "",
	areaBlockLocationDetail: ""
};
